import React, { useMemo } from "react";

const CountBadge = ({ styles, count }) => (
  <span className={styles.countBadge}>{count}</span>
);

const ListCard = ({ styles, title, count, children }) => (
  <section className={styles.listCard}>
    <div className={styles.listCardHeader}>
      <div className={styles.listCardTitleRow}>
        <div className={styles.listCardTitle}>{title}</div>
        <CountBadge styles={styles} count={count} />
      </div>
    </div>

    <div className={styles.listCardBody}>{children}</div>
  </section>
);

const YearDivider = ({ styles, year }) => (
  <div className={styles.yearDivider}>
    <span className={styles.yearPill}>{year}</span>
    <div className={styles.yearLine} />
  </div>
);

const PaperRow = ({ styles, title }) => (
  <div className={styles.row}>
    <div className={styles.rowTitle}>{title}</div>
  </div>
);

const PatentRow = ({ styles, title, no }) => (
  <div className={styles.row}>
    <div className={styles.rowTitle}>{title}</div>
    <div className={styles.rowMeta}>
      <span className={styles.patentNo}>{no}</span>
    </div>
  </div>
);

const AIPaperSection = ({ styles }) => {
  const papersByYear = useMemo(
    () => [
      {
        year: "2025",
        items: [
          { title: "도메인 전문성 강화를 위한 LLM 파인튜닝" },
          { title: "자동 목차 추출을 위한 생성형 인공지능 기반 모델의 파인튜닝에 관한 연구" },
        ],
      },
      {
        year: "2024",
        items: [
          { title: "RAG 시스템 성능 향상을 위한 웹문서 본문 정제 및 추출 시스템" },
          { title: "LLM을 이용한 바이러스 코드의 클론 생성 기법" },
        ],
      },
      {
        year: "2023",
        items: [
          { title: "영상을 통한 실시간 반려견 행동 인식 시스템" },
          { title: "벡터의 성질을 활용한 딥러닝 기반 노인 낙상 감지 알고리즘" },
          { title: "세그멘테이션 라벨링 없는 최소 전처리를 통한 AI 의료 영상에서의 다 질병 진단 효율화" },
        ],
      },
      {
        year: "2022",
        items: [
          { title: "AI 기법을 이용한 반려동물의 행동 및 감정 탐지" },
          { title: "인공지능 기법을 이용한 알레르기 반응 여부 판단" },
        ],
      },
      {
        year: "2021",
        items: [
          { title: "동영상에서 음성과 이미지 데이터를 이용한 진술의 거짓말 탐지" },
          { title: "목적지로 자율 주행 가능한 강화 학습 로봇" },
          { title: "GP를 이용한 Assembly 코드 자동 생성 시스템 설계" },
        ],
      },
    ],
    []
  );

  const patents = useMemo(
    () => [
      {
        title: "검색증강생성방법 및 그 장치(Retrieval-augmented generation method and apparatus therefor)",
        no: "특허출원 제25-88069호",
      },
      {
        title: "음란이미지 자동인식 방법, 장치 및 그 방법을 실행하기 위한 프로그램 기록매체",
        no: "특허 1020110044674",
      },
    ],
    []
  );

  const paperCount = useMemo(
    () => papersByYear.reduce((acc, g) => acc + g.items.length, 0),
    [papersByYear]
  );

  return (
    <div className={styles.page}>
      <div className={styles.containerNarrow}>
        <div className={styles.cardStack}>
          {/* 발표 논문 */}
          <ListCard styles={styles} title="발표 논문" count={paperCount}>
            <div className={styles.scrollArea}>
              {papersByYear.map((g) => (
                <div key={g.year} className={styles.group}>
                  <YearDivider styles={styles} year={g.year} />
                  <div className={styles.rows}>
                    {g.items.map((p, i) => (
                      <PaperRow key={`${g.year}-${i}`} styles={styles} title={p.title} />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </ListCard>

          {/* 특허 */}
          <ListCard styles={styles} title="특허" count={patents.length}>
            <div className={styles.scrollArea}>
              <div className={styles.rows}>
                {patents.map((p, i) => (
                  <PatentRow
                    key={i}
                    styles={styles}
                    title={`${i + 1}. ${p.title}`}
                    no={p.no}
                  />
                ))}
              </div>
            </div>
          </ListCard>
        </div>
      </div>
    </div>
  );
};

export default AIPaperSection;
